import axios from 'axios'
import { MISC_API_URL } from 'lib/env'
import { createError } from 'requests/errors'

export const getSupportList = async filter => {
  try {
    const res = await axios.post(MISC_API_URL + '/support/list', filter)
    return res.data
  } catch (e) {
    return createError(e)
  }
}

export const getSupportById = async id => {
  try {
    const res = await axios.get(MISC_API_URL + '/support/' + id)
    return res.data
  } catch (e) {
    return createError(e)
  }
}

export const updateSupportById = async data => {
  try {
    const response = await axios.patch(`${MISC_API_URL}/support`, data)

    return response.data
  } catch (error) {
    return createError(error)
  }
}

export const createSupport = async data => {
  try {
    const res = await axios.post(MISC_API_URL + '/support', data)
    return res.data
  } catch (e) {
    return createError(e)
  }
}

export const postPhoto = async file => {
  try {
    const formData = new FormData()
    formData.append('file', file)
    const res = await axios.post(MISC_API_URL + '/files/uploadFile', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return res.data
  } catch (e) {
    return createError(e)
  }
}
